export default __webpack_public_path__ + "static/media/3.e3264076.svg";